import { Stack } from '@mui/material';
import { FC } from 'react';
import Text from '@/components/text';
import useUserSettings from '@/hooks/use-user-settings.hook';
import UserSettingsCard from './card';
import Switch from '@/components/form/switch';
import Icon from '@/components/icon';
import CardDetail from './card-detail';

const PublicDatasourceCard: FC = () => {
  const { isLoading, threadSettings, togglePublicSearch } = useUserSettings();
  const { publicSearchEnabled } = threadSettings;

  return (
    <UserSettingsCard title="Public Data Sources" loading={isLoading}>
      <CardDetail>Choose the public data sources to search when sending a prompt.</CardDetail>

      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" alignItems="center" gap={0.5} flexGrow={1}>
          <Icon name="globe" size="small" />
          <Text size="small">Internet</Text>
        </Stack>

        <Switch
          name="public-internet-search"
          checked={publicSearchEnabled}
          onChange={togglePublicSearch}
          size="small"
          fullWidth={false}
        />
      </Stack>
    </UserSettingsCard>
  );
};

export default PublicDatasourceCard;
